import { Link } from "react-router-dom";
import { Facebook, Mail } from "lucide-react";
import riekelsLogo from "@/assets/riekels-logo.png";

const services = [
  { name: "Lawn Care", path: "/services/lawn-care" },
  { name: "Aeration & Overseeding", path: "/services/aeration" },
  { name: "Mulching & Beds", path: "/services/mulching" },
  { name: "Dethatching", path: "/services/dethatching" },
  { name: "Spring & Fall Cleanups", path: "/services/spring-fall-cleanups" },
  { name: "Snow Removal", path: "/services/snow-removal" },
];

const quickLinks = [
  { name: "About Us", path: "/about" },
  { name: "Projects", path: "/projects" },
  { name: "Service Areas", path: "/service-areas" },
  { name: "Careers", path: "/careers" },
  { name: "Contact", path: "/contact" },
];

export const Footer = () => {
  return (
    <footer className="bg-footer text-footer-foreground" role="contentinfo">
      <div className="container mx-auto px-4 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Logo & About */}
          <div className="space-y-6">
            <Link to="/" aria-label="Riekels Lawn Care & Landscaping - Home">
              <img
                src={riekelsLogo}
                alt="Riekels Lawn Care & Landscaping logo"
                className="h-16 w-auto bg-white p-2 rounded-lg"
                width={160}
                height={64}
                loading="lazy"
                decoding="async"
              />
            </Link>
            <p className="text-footer-foreground/80 leading-relaxed">
              Professional lawn care, landscaping, and snow removal services for the West Twin Cities Metro and surrounding Minnesota communities.
            </p>
            <div className="flex gap-4">
              <a
                href="https://www.facebook.com/p/Riekels-Lawn-Care-Landscaping-61579777854111/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-secondary/20 flex items-center justify-center hover:bg-secondary transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-secondary focus-visible:ring-offset-2 focus-visible:ring-offset-footer"
                aria-label="Visit Riekels on Facebook"
              >
                <Facebook className="w-5 h-5" aria-hidden="true" />
              </a>
            </div>
          </div>

          {/* Services */}
          <nav aria-label="Services">
            <h2 className="text-lg font-heading font-semibold text-primary-foreground mb-6">
              Our Services
            </h2>
            <ul className="space-y-3">
              {services.map((service) => (
                <li key={service.path}>
                  <Link
                    to={service.path}
                    className="text-footer-foreground/80 hover:text-secondary transition-colors focus:outline-none focus-visible:text-secondary focus-visible:underline"
                  >
                    {service.name}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          {/* Quick Links */}
          <nav aria-label="Quick Links">
            <h2 className="text-lg font-heading font-semibold text-primary-foreground mb-6">
              Quick Links
            </h2>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-footer-foreground/80 hover:text-secondary transition-colors focus:outline-none focus-visible:text-secondary focus-visible:underline"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          {/* Contact Info */}
          <div>
            <h2 className="text-lg font-heading font-semibold text-primary-foreground mb-6">
              Contact Us
            </h2>
            <address className="not-italic space-y-4 text-footer-foreground/80">
              <div>
                <span className="block font-medium text-primary-foreground">Phone</span>
                <a
                  href="tel:+17632457813"
                  className="hover:text-secondary transition-colors focus:outline-none focus-visible:text-secondary focus-visible:underline"
                  aria-label="Call Riekels at (763) 245-7813"
                >
                  (763) 245-7813
                </a>
              </div>
              <div>
                <span className="block font-medium text-primary-foreground">Email</span>
                <a
                  href="mailto:riekelslcl@gmail.com"
                  className="hover:text-secondary transition-colors focus:outline-none focus-visible:text-secondary focus-visible:underline flex items-center gap-2"
                  aria-label="Email Riekels at riekelslcl@gmail.com"
                >
                  riekelslcl@gmail.com
                </a>
              </div>
              <div>
                <span className="block font-medium text-primary-foreground">Service Area</span>
                West Twin Cities Metro Area, MN and
                <br />
                surrounding communities
              </div>
            </address>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-primary-foreground/10">
        <div className="container mx-auto px-4 py-6">
          <p className="text-center text-footer-foreground/60 text-sm">
            © 2026 Riekels Lawn Care & Landscaping. Built By{" "}
            <a
              href="https://www.skillmammoth.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-secondary hover:underline focus:outline-none focus-visible:underline"
            >
              Skill Mammoth Digital
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};
